import * as React from "react";
import moment from "moment";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  EnhancedInstrumentSearchResult,
  InstrumentSearchResultV3,
} from "@iliotech/generated-api-v3";
import cn from "classnames";
import s from "./Cells.module.scss";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { observer } from "mobx-react-lite";
import { usePositionUploadV2 } from "@iliotech/data-wire/src/stores/PositionsUpload";

const NameCell = ({ index }: { index: number; baseCurrency: string }) => {
  const store = usePositionUploadV2();

  const searchResults = (store.position.getField("searchResults", index + "") ||
    []) as EnhancedInstrumentSearchResult[];
  const selectedInstrument = store.position.getField(
    "selectedInstrument",
    index + ""
  ) as EnhancedInstrumentSearchResult;

  const defaultValue = {
    name: searchResults.length + " found",
    code: "",
    currency: "",
  };
  const trimText = (text: string) =>
    text.length > 20 ? text.substring(0, 20) + "..." : text;

  const selectedInstrumentName = (
    instrument: EnhancedInstrumentSearchResult & { currencyCode: string }
  ) =>
    instrument?.name
      ? `${instrument?.name} - ${instrument?.code} (${
          instrument?.currency || instrument.currencyCode
        })`
      : "null";

  const parsedSearchResults = searchResults.map((item) => ({
    ...item,
    name: selectedInstrumentName(item as any),
  }));
  // console.log({ selectedInstrument });

  const onChangeSelectedInstrument = async (event: DropDownListChangeEvent) => {
    const instrument: EnhancedInstrumentSearchResult = event.value;
    store.position.updateTableRowByIndex(
      "historicPrice",
      instrument.price,
      index + ""
    );
    store.position.updateTableRowByIndex(
      "fxRate",
      instrument.fxRate,
      index + ""
    );
    store.position.updateTableRowByIndex(
      "currency",
      instrument.currency,
      index + ""
    );
    store.position.updateTableRowByIndex(
      "selectedInstrument",
      event.value,
      index + ""
    );
    store.position.updateTableRowByIndex(
      "status",
      {
        status: event.value?.instrumentStatus,
        sourceId: event.value?.sourceId?.sourceId,
      },
      index + ""
    );
  };

  if (searchResults.length > 1) {
    return (
      <DropDownList
        popupSettings={{ popupClass: "illio-combo" }}
        className={cn(!selectedInstrument && s.dropdownWarning)}
        value={selectedInstrument || defaultValue}
        onChange={onChangeSelectedInstrument}
        textField={"name"}
        data={parsedSearchResults}
      />
    );
  }

  return (
    <Tooltip>
      <div title={selectedInstrumentName(selectedInstrument! as any)}>
        {index}
      </div>
    </Tooltip>
  );
};

export default observer(NameCell);
